(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4413],{

/***/ 74413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27693);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62062);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var ab_api_queries__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75433);
/* harmony import */ var ab_text__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(145);
/* harmony import */ var ab_link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(276);
/* harmony import */ var _ab_noticias_cross_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(83782);
/* harmony import */ var _ab_noticias_cross_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_ab_noticias_cross_scss__WEBPACK_IMPORTED_MODULE_8__);









var NoticiasCross = function(param) {
    var classname = param.classname, title = param.title, text = param.text, link = param.link, i18n = param.i18n;
    // console.log("notiicascross", language);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), posts = ref[0], setPosts = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        (0,ab_api_queries__WEBPACK_IMPORTED_MODULE_5__/* .getPosts */ .Jq)({
            first: 2,
            where: {
                language: i18n.language == "ES" ? "ES" : "EN"
            }
        }).then(function(res) {
            var ref;
            // console.log("NoticiasCross -res", res);
            setPosts((ref = res.posts) === null || ref === void 0 ? void 0 : ref.nodes);
        });
    }, []);
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("common", {
        i18n: i18n
    }).t;
    // console.log("NoticiasCross");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "ab-noticias-cross ".concat(classname || ""),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "left",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        element: "h2",
                        animated: true,
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        children: text
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_link__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        prefetch: false,
                        text: link === null || link === void 0 ? void 0 : link.title,
                        href: link === null || link === void 0 ? void 0 : link.url
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "right",
                children: posts.map(function(itm, index) {
                    var ref, ref1, ref2, ref3, ref4;
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "noticias-tile",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                src: (itm === null || itm === void 0 ? void 0 : (ref = itm.featuredImage) === null || ref === void 0 ? void 0 : (ref1 = ref.node) === null || ref1 === void 0 ? void 0 : ref1.mediaItemUrl) || "/images/404.png",
                                width: 381,
                                height: 381,
                                objectFit: "cover",
                                alt: "cross"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                element: "span",
                                className: "title",
                                children: dayjs__WEBPACK_IMPORTED_MODULE_2___default()(itm === null || itm === void 0 ? void 0 : itm.date).format("MMMM DD, YYYY")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                element: "h4",
                                children: itm === null || itm === void 0 ? void 0 : itm.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                children: itm === null || itm === void 0 ? void 0 : (ref2 = itm.contenidoFlexible) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.modulos) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : ref4.excerpt
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_link__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                prefetch: false,
                                text: t("leer-mas"),
                                href: "".concat(t("/blog"), "/").concat(itm === null || itm === void 0 ? void 0 : itm.slug)
                            })
                        ]
                    }, "noticias-cross-".concat(index));
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (NoticiasCross);


/***/ }),

/***/ 83782:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);